import { track } from '../../services/analytics';

const analyticsMiddleware = (config) => (store) => (next) => (action) => {
  try {
    const { type } = action;
    const eventConfig = config[type];
    if (eventConfig) {
      const props = eventConfig.getProps(store, action);
      track(eventConfig.eventName, props);
    }
    return next(action);
  } catch (err) {
    console.warn('Error tracking event: ', err);
    return next(action);
  }
};

export default analyticsMiddleware;
